import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { AbstractDetailsComponent } from '../../../../shared/abstracts/details/abstract-details/abstract-details.component';
import { IReference } from '@ahryman40k/ts-fhir-types/lib/R4';
import { ActionSheetController } from '@ionic/angular';
import { TranslatePipe } from '../../../../shared/translate/pipes/translate.pipe';
import { stringToDefinitionView } from '../../../functions/observation-definition.function';
import { DefinitionView, ModalType } from '../../../models/observation-definition.model';

const CUSTOM_COLS = [
  { name: 'CUSTOM_ALERTS', colSize: 3 },
  { name: 'Minimum', colSize: 3 },
  { name: 'Maximum', colSize: 5.3 }
];

const TIME_SERIES_COLS = [
  { name: 'TIME_SERIES_ALERTS', colSize: 3 },
  { name: 'SCHEDULE', colSize: 3 },
  { name: 'OPERATION', colSize: 3 },
  { name: 'ALERT', colSize: 2.3 }
];

@Component({
  selector: 'inc-observation-definition-details',
  templateUrl: './observation-definition-details.component.html',
  styleUrls: ['./observation-definition-details.component.scss'],
})
export class ObservationDefinitionDetailsComponent extends AbstractDetailsComponent<IReference[]> implements OnInit {
  @Output() callDelete = new EventEmitter<IReference>();
  @Output() callUpdate = new EventEmitter<{ data: IReference, modalType: ModalType }>();

  customCols = CUSTOM_COLS;
  timeSeriesCols = TIME_SERIES_COLS;
  definitionView: DefinitionView;

  constructor(private actionSheetController: ActionSheetController, private translatePipe: TranslatePipe) {
    super();
  }

  ngOnInit() {
    this.setDefinitionView();
  }

  setDefinitionView() {
    this.definitionView = stringToDefinitionView(this.inData, this.translatePipe);
  }

  delete(data: IReference) {
    this.callDelete.emit(data);
  }

  update(data: IReference, modalType: ModalType) {
    this.callUpdate.emit({ data, modalType });
  }

  async openActionSheet(reference: string, modalType: ModalType) {
    const actionSheet = await this.actionSheetController.create({
      buttons: [{
        text: this.translatePipe.transform('EDIT_L'),
        icon: 'create',
        handler: () => { this.update(this.inData.filter(data => data.reference === reference)[0], modalType); }
      },
      {
        text: this.translatePipe.transform('DELETE_L'),
        icon: 'trash',
        handler: () => { this.delete(this.inData.filter(data => data.reference === reference)[0]); }
      }]
    });
    await actionSheet.present();
  }
}
